import React from "react";
import classes from "./FaqLists.module.css";

export default function FaqLists() {
    return (
        <div className="row between-md">
            <div className="col-md-5 col-sm-6 col-xs-12">
                <div className={classes.item}>
                    <div className={classes.title_faq}>
                        <h4>
                            How to get <br className={classes.dn} /> into OG?
                        </h4>
                        <div className={classes.title_frame}>
                            <svg
                                width="38"
                                height="94"
                                viewBox="0 0 38 94"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2 2C16.8233 10.9106 27.7884 25.0317 32.75 41.6001C37.5852 58.2271 36.0302 76.061 28.3901 91.6001"
                                    stroke="white"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className={classes.faq_desc}>
                        <div className={classes.desc_frame}>
                            <svg
                                width="32"
                                height="86"
                                viewBox="0 0 32 86"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12.1028 2C7.66321 8.51301 4.59385 15.8605 3.08109 23.5962C1.56834 31.3319 1.64394 39.2944 3.30302 47C5.05428 54.6884 8.35089 61.9403 12.9925 68.3147C17.6341 74.6891 23.5236 80.0527 30.303 84.0798"
                                    stroke="white"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                        <p className={classes.desc_text}>
                            Write in your Twitter account how you can be useful and tag our
                            account. We will make <br /> a decision
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12">
                <div className={classes.item}>
                    <div className={classes.title_faq}>
                        <h4>
                            Where will the NFTs <br /> be hosted?
                        </h4>
                        <div className={`${classes.title_frame} ${classes.second}`}>
                            <svg width="38" height="94" viewBox="0 0 38 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 2C16.8233 10.9106 27.7884 25.0317 32.75 41.6001C37.5852 58.2271 36.0302 76.061 28.3901 91.6001" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div className={`${classes.faq_desc} ${classes.second}`}>
                        <div className={classes.desc_frame}>
                            <svg width="64" height="86" viewBox="0 0 64 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.97666 8.43202C8.02022 16.256 8.66417 24.1927 10.8693 31.7602C13.0745 39.3277 16.795 46.3679 21.8046 52.4534C26.8882 58.4812 33.1447 63.4122 40.1936 66.9464C47.2425 70.4806 54.9365 72.5441 62.8079 73.0118" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <p className={classes.desc_text}>
                            OpenSea Magic Eden
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-md-5 col-sm-6 col-xs-12">
                <div className={classes.item}>
                    <div className={classes.title_faq}>
                        <h4>
                        supply?
                        </h4>
                        <div className={`${classes.title_frame} ${classes.third}`}>
                            <svg width="38" height="94" viewBox="0 0 38 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 2C16.8233 10.9106 27.7884 25.0317 32.75 41.6001C37.5852 58.2271 36.0302 76.061 28.3901 91.6001" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div className={classes.faq_desc}>
                        <div className={classes.desc_frame}>
                            <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.59316 2C1.78912 5.14168 1.80277 8.43677 2.63247 11.5718C3.46216 14.7068 5.08029 17.5773 7.33315 19.9099C9.63387 22.1982 12.4824 23.8594 15.6071 24.7346C18.7318 25.6099 22.0286 25.6701 25.1832 24.9099" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <p className={classes.desc_text}>
                            777
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-md-5 col-sm-6 col-xs-8">
                <div className={classes.item}>
                    <div className={classes.title_faq}>
                        <h4>
                            Date and time of sale
                        </h4>
                        <div className={`${classes.title_frame} ${classes.fourth}`}>
                            <svg width="58" height="43" viewBox="0 0 58 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.7866 8.80919L11.3505 41.0168" stroke="white" strokeWidth="2.12845" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M1.96057 16.8406L29.5602 34.8771" stroke="white" strokeWidth="2.12845" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M49.3743 1.33794L44.4223 22.8817" stroke="white" strokeWidth="2.12845" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M34.7946 9.30212L54.5176 19.1386" stroke="white" strokeWidth="2.12845" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div className={classes.faq_desc}>
                        <div className={classes.desc_frame}>
                            <svg width="49" height="44" viewBox="0 0 49 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.15136 2C1.59067 7.36152 1.61716 12.9848 3.22765 18.335C4.83815 23.6851 7.97902 28.5838 12.3519 32.5646C16.8178 36.4698 22.3469 39.3046 28.4121 40.7983C34.4773 42.292 40.8766 42.3949 47 41.0975" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <p className={classes.desc_text}>
                            30 june
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-md-5 col-sm-6 col-xs-12">
                <div className={classes.item}>
                    <div className={classes.title_faq}>
                        <h4>
                            How to get WL <br />
                            for my DAO?
                        </h4>
                    </div>
                    <div className={classes.faq_desc}>
                        <div className={classes.desc_frame}>
                            <svg width="32" height="74" viewBox="0 0 32 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.1028 2C7.66321 7.55448 4.59385 13.8206 3.08109 20.4178C1.56834 27.0151 1.64394 33.8057 3.30302 40.3773C5.05428 46.9341 8.35089 53.1187 12.9925 58.555C17.6341 63.9913 23.5236 68.5656 30.303 72" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <p className={classes.desc_text}>
                            Contact us on Twitter. <br />
                            We watch chats every day
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-md-5 col-sm-6 col-xs-12">
                <div className={classes.empty}>
                    <div className={classes.first_frame}>
                        <svg width="164" height="70" viewBox="0 0 164 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M162 3.53095C106.813 23.3161 53.4049 44.8459 2 68.0303C36.934 44.543 76.8677 23.9353 120.766 6.74148C81.1331 14.6237 45.8437 28.5295 11 42.2862C28.1163 29.1896 47.4047 17.1767 68.5663 6.43335L14.3358 21.1641C17.9792 14.7821 24.601 9.16733 33.4088 4.99206L10.5211 10.8864L16.8953 2.00017" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className={classes.second_frame}>
                        <svg width="164" height="71" viewBox="0 0 164 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 66.9847C57.187 47.1996 110.595 25.6697 162 2.48535C127.066 25.9726 87.1323 46.5803 43.2343 63.7741C82.8669 55.8919 118.156 41.9861 153 28.2294C135.884 41.326 116.595 53.339 95.4337 64.0823L149.664 49.3515C146.021 55.7335 139.399 61.3483 130.591 65.5236L153.479 59.6293L147.105 68.5154" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className={classes.second_third}>
                        <svg width="62" height="27" viewBox="0 0 62 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.999998 1.57409C21.6951 8.99351 41.7232 17.0672 61 25.7613C47.8998 16.9536 32.9246 9.22574 16.4629 2.77804C31.3251 5.73389 44.5587 10.9486 57.625 16.1073C51.2064 11.1961 43.9733 6.69124 36.0377 2.66249L56.3741 8.18654C55.0078 5.79328 52.5246 3.68774 49.2217 2.12201L57.8046 4.33237L55.4143 1.00005" stroke="white" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className={classes.frame_coin}>
                        <svg width="54" height="61" viewBox="0 0 54 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.9287 9.43615L4.99646 25.1227" stroke="#FFC700" strokeWidth="1.59281" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M1.49268 12.8456L17.9473 25.8118" stroke="#FFC700" strokeWidth="1.59281" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M40.42 1.242C38.9477 8.19151 35.8377 14.6892 31.3488 20.1949" stroke="#FFC700" strokeWidth="1.59281" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M27.1807 4.39088L45.2571 18.6672" stroke="#FFC700" strokeWidth="1.59281" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M18.1191 39.4909C26.2904 40.0251 34.4825 38.8328 42.1624 35.9914C38.6496 38.6332 35.4357 41.6506 32.5779 44.99C29.7008 48.3575 28.0042 52.5736 27.7466 56.9953" stroke="#FFC700" strokeWidth="1.59281" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
}
